import { loadCacheFromLocalStorage, toRestoreGridPage } from '../../../../helpers/localStorage';
import { INITIAL_SORT, ALL_COLUMNS, INITIAL_FILTERS, INITIAL_PAGE } from '../constants';

export const getInitialData = (cacheKey) => {
  const cache = loadCacheFromLocalStorage(cacheKey);
  if (cacheIsValid(cache, cacheKey)) {
    return {
      ...cache,
      filters: withNewFilters(cache.filters),
      loading: true,
      page: toRestoreGridPage() && cache.page ? cache.page : INITIAL_PAGE
    };
  }

  return {
    page: INITIAL_PAGE,
    sort: INITIAL_SORT,
    filters: INITIAL_FILTERS,
    columns: ALL_COLUMNS,
    loading: true
  };
};

// IP-15560. A cached grid is restored wholesale, so a filter added after a user's cache was written
// would never appear for them -- they would have to hit Reset Cache and lose their column and sort
// preferences to discover it. Backfill only the keys the cache is missing; a cached value always
// wins, so this never overrides what the user chose. Same fix the buildings grid got in IP-15509.
const withNewFilters = (cached) => ({
  ...cached,
  values: { ...INITIAL_FILTERS.values, ...cached.values },
  active: { ...INITIAL_FILTERS.active, ...cached.active },
  operators: { ...INITIAL_FILTERS.operators, ...cached.operators }
});

const cacheIsValid = (cache, cacheKey) => {
  if (!cache) return false;

  if (
    cache.filters?.values &&
    cache.filters?.active &&
    cache.filters?.operators &&
    cache.sort &&
    typeof cache.columns?.[0] === 'string'
  )
    return true;

  localStorage.removeItem(cacheKey);
  return false;
};
